module.exports = __webpack_public_path__ + "static/media/13-10.65f9909c.mp3";